<template>
  <q-dialog v-model="show" persistent>
    <q-card>
      <q-card-section>
        <div class="text-h6 text-primary text-center">
          The request has been sent
        </div>
        <div class="text-center">
          We have sent a request to {{ destination.firstName }}
          {{ destination.lastName }} ({{ destination.phoneNumber }})
        </div>
      </q-card-section>

      <q-card-section class="row justify-center">
        <q-img
          class="q-mb-md"
          basic
          :src="require(`@/assets/payment/wallet-logo.png`)"
          contain
          style="max-height: 100px"
        />
        <div class="text-center">Checking payment status. Please wait...</div>
        <div class="text-red text-center">
          โปรดกดชำระเงินให้เรียบร้อยภายใน 10 นาที เหลือเวลา
          {{ timeCounterStr }}
        </div>
        <div class="text-center">
          กรุณาอย่าปิดหน้าจอ จนกว่าการชำระเงินสำเร็จ
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          no-wrap
          no-caps
          flat
          label="Cancel"
          color="primary"
          @click="onClose"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import dayjs from "dayjs";
import axios from "axios";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

import { QDialog, QCard, QCardSection, QCardActions } from "quasar";
const components = { QDialog, QCard, QCardSection, QCardActions };

export default {
  name: "RequestToPayForm",
  components: {
    ...components,
  },
  data() {
    return {
      show: false,
      destination: {
        firstName: "-",
        lastName: "-",
        phoneNumber: "-",
      },
      amount: "-",
      queryUrl: null,
      timeCounter: 600,
      timeCounterStr: "",
      timer: null,
      polling: null,
    };
  },
  methods: {
    setInfo(info) {
      console.log("RequestToPayForm setInfo", info);
      //   this.qr = info.qrcode;
      this.queryUrl = info.queryUrl;
      this.destination.firstName = info.data.first_name;
      this.destination.lastName = info.data.last_name;
      this.destination.phoneNumber = info.data.phone_number;
    },
    submit() {
      console.log("RequestToPayForm submit");
      this.show = true;
      this.timer = setInterval(() => {
        this.timeCounter--;

        this.timeCounterStr = dayjs
          .duration(this.timeCounter, "seconds")
          .format("m:ss");

        if (this.timeCounter <= 0) {
          this.onClose();
        }
      }, 1000);

      this.polling = setInterval(() => {
        console.log("check payment status");
        if (this.queryUrl) {
          axios
            .get(`${this.queryUrl}&random=${100000 * Math.random()}`)
            .then((response) => {
              console.log(response.data);
              let { status, amount, orderId } = response.data;

              switch (status) {
                case "PAID":
                  {
                    // redirect to pay success page
                    console.log(
                      "redirect to pay success page",
                      amount,
                      orderId
                    );
                    clearInterval(this.polling);
                    this.polling = null;
                    this.show = false;
                    this.$router.push(
                      `/thankyou?status=success&orderId=${orderId}&amount=${amount}`,
                      () => {
                        //
                      }
                    );
                  }
                  break;
                case "FAILED":
                  {
                    // redirect to pay fail page
                    console.log("redirect to pay fail page", amount, orderId);
                    clearInterval(this.polling);
                    this.polling = null;
                    this.show = false;
                    this.$router.push(
                      `/thankyou?status=fail&orderId=${orderId}&amount=${amount}`,
                      () => {
                        //
                      }
                    );
                  }
                  break;
                default:
                  break;
              }
            });
        }
      }, 3000);
    },
    onClose() {
      this.show = false;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.polling) {
        clearInterval(this.polling);
        this.polling = null;
      }

      this.queryUrl = null;
      this.timeCounter = 600;
    },
  },
};
</script>

<style></style>
